import { createContext, useContext } from 'react';
export const LegacyQueryParamsContext = /*#__PURE__*/createContext({});

/**
 * @deprecated crm-timeline should be URL-agnostic and any contextual data
 * should be passed through the component hierarchy as props.
 */
export function useLegacyQueryParams() {
  return useContext(LegacyQueryParamsContext);
}